import type { FC } from 'react';

import { CurrencyConnected } from '@pp/core/src/components/currency/CurrencyConnected';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';

import styles from './CashedAndTotalBets.module.css';

type BetType = number | string | undefined;

interface CashedBetsProps {
  betCount: BetType;
  cashedAmount: BetType;
  cashedBetCount: BetType;
}

export const CashedBets: FC<CashedBetsProps> = ({ betCount = 0, cashedAmount = 0, cashedBetCount = 0 }) => {
  return (
    <>
      <div className={styles.cashedBets_container}>
        <div>
          <L10nText tk="CRASH_CASHED_BETS" />:<span>&nbsp;</span>
        </div>
        <div className={styles.cashedAmount}>{cashedBetCount}</div>
        <div className={styles.separator}></div>
        <div className={styles.placedAmount}>{betCount}</div>
      </div>
      <div className={styles.totalAmountCashed}>
        <CurrencyConnected value={Number(cashedAmount)} />
      </div>
    </>
  );
};
